import { render, staticRenderFns } from "./AddActivityRegistration.vue?vue&type=template&id=3f15ccbc&scoped=true&"
import script from "./AddActivityRegistration.vue?vue&type=script&lang=js&"
export * from "./AddActivityRegistration.vue?vue&type=script&lang=js&"
import style0 from "./AddActivityRegistration.vue?vue&type=style&index=0&id=3f15ccbc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f15ccbc",
  null
  
)

export default component.exports